// extracted by mini-css-extract-plugin
module.exports = {"authorText":"e_07"};